<template>
    <AnagraficaCrud titolo="Certificati di prova (prestazioni dichiarate)" endpoint="certificati"
        nuovo-label="Nuovo certificato" :colonne="colonne" :campi="campi" :filtri="filtri"
        :puo-scrivere="puoScrivere" :limite="5000"
        colonne-import="Codice, Descrizione, Condizione, Tipo (Acustica, Acqua, Permeabilita, Vento, Urto), CodProgetto, PF (P, F o vuoto), Spessore, L (larghezza campione), H (altezza campione), Risultato, IgurwVetro, IgurwPannello, TipoAlluminio." />
</template>

<script>
import AnagraficaCrud from "@/components/AnagraficaCrud.vue";

const TIPI = ["Acustica", "Acqua", "Permeabilita", "Vento", "Urto"];

export default {
    name: "CertificatiPage",
    components: { AnagraficaCrud },

    data() {
        return {
            colonne: [
                { title: "Codice", key: "codice" },
                { title: "Tipo", key: "tipo" },
                { title: "Progetto", key: "codProgetto" },
                { title: "P/F", key: "pf" },
                { title: "Spessore", key: "spessore" },
                { title: "L", key: "l" },
                { title: "H", key: "h" },
                { title: "Risultato", key: "risultato" },
                { title: "Rw vetro", key: "igurwVetro" },
                { title: "Rw pannello", key: "igurwPannello" },
            ],
            campi: [
                { key: "codice", label: "Codice", tipo: "text", required: true },
                { key: "tipo", label: "Tipo", tipo: "select", items: TIPI, required: true },
                { key: "codProgetto", label: "Codice progetto", tipo: "text", required: true },
                { key: "pf", label: "P/F", tipo: "select", items: ["", "P", "F"], hint: "Vuoto = valido per porta e finestra" },
                { key: "spessore", label: "Spessore anta (mm)", tipo: "number", step: 1, default: 0, required: true, hint: "Usato dalla ricerca acustica" },
                { key: "l", label: "Larghezza campione (mm)", tipo: "number", default: 0, required: true },
                { key: "h", label: "Altezza campione (mm)", tipo: "number", default: 0, required: true },
                { key: "risultato", label: "Risultato", tipo: "text", hint: "Es. 40(-1,-4) dB, CLASSE 4, E1200" },
                { key: "igurwVetro", label: "Rw vetro della prova (dB)", tipo: "number", default: 0, required: true },
                { key: "igurwPannello", label: "Rw pannello della prova (dB)", tipo: "number", default: 0, required: true },
                { key: "descrizione", label: "Descrizione", tipo: "text" },
                { key: "condizione", label: "Condizione", tipo: "text" },
                { key: "tipoAlluminio", label: "Tipo alluminio", tipo: "text" },
            ],
            filtri: [
                { key: "tipo", label: "Tipo", items: TIPI },
            ],
        };
    },

    computed: {
        puoScrivere() {
            const ruolo = this.$store.getters["user/getRole"];
            return ruolo === "Admin" || ruolo === "SuperAdmin";
        },
    },
};
</script>
